/* eslint-disable react/jsx-props-no-spreading */
import React, { FC } from 'react';
import AntdTooltip, { TooltipProps } from 'antd/lib/tooltip';

import 'antd/lib/tooltip/style/index.css';
import style from './style.module.scss';

const Tooltip: FC<TooltipProps> = ({ title, children, ...restProps }) => {
  return (
    <AntdTooltip
      title={<span>{title}</span>}
      overlayClassName={style.tooltip}
      destroyTooltipOnHide={{ keepParent: false }}
      {...restProps}
    >
      {children}
    </AntdTooltip>
  );
};

export default Tooltip;
